import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common'

/*
  Generated class for the PostProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class WellBeingProvider {
  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) {}

  private _url: string = this.commonProvider.apiUrl + 'api/v1/wellbeing';

  saveReport(value): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._url + '/weeklyreport/create', {value});
  }

  shouldFill(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._url + '/weeklyreport/user/shouldfill');
  }


}




// WEBPACK FOOTER //
// ./src/providers/wellbeing/wellbeing.ts